/* nabi — product page: tone/size picker, retint, add to bag */
(function () {
  'use strict';
  const root = document.querySelector('[data-product-section]');
  if (!root || root.dataset.bound) return; root.dataset.bound = '1';
  const $ = (s, r) => (r || root).querySelector(s);
  const $$ = (s, r) => [...(r || root).querySelectorAll(s)];
  const jsonEl = document.querySelector('[data-product-json]');
  const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
  const form = $('[data-product-form]');
  const idInput = $('[data-variant-id]');
  const money = cents => {
    const fmt = (window.nabi && window.nabi.moneyFormat) || '${{amount}}';
    const amt = (cents / 100).toFixed(2);
    const noDec = (cents / 100).toFixed(0);
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec).replace(/\{\{\s*amount(_with_comma_separator|_no_decimals_with_comma_separator)?\s*\}\}/, amt).replace(/<[^>]+>/g, '');
  };

  /* selected option values, in option order */
  const groups = $$('[data-option-index]');
  const selected = () => groups.map(g => { const c = g.querySelector('input:checked'); return c ? c.value : null; });
  const findVariant = vals => product && product.variants.find(v => vals.every((val, i) => val === null || v['option' + (i + 1)] === val));

  const toneName = $('[data-tone-name]');
  const toneVal = $('[data-tone-val]');
  const priceEl = $('[data-price]');
  const compareEl = $('[data-compare]');
  const addBtn = $('[data-add-btn]');
  const addLabel = $('[data-add-label]');
  const arrowSvg = addLabel ? (addLabel.querySelector('svg') ? addLabel.querySelector('svg').outerHTML : '') : '';
  const defaultLabel = addBtn ? ((addBtn.dataset.label || 'Add to bag') + ' ' + arrowSvg) : '';

  const retint = label => {
    if (!label) return;
    const d = label.dataset;
    if (d.a) root.style.setProperty('--tone-a', d.a);
    if (d.b) root.style.setProperty('--tone-b', d.b);
    if (d.deep) root.style.setProperty('--tone-deep', d.deep);
    if (d.a) root.style.setProperty('--tone-c', lighten(d.a));
    if (d.b) root.style.setProperty('--tone-d', lighten(d.b));
  };
  const lighten = hex => {
    const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim()); if (!m) return hex;
    const n = parseInt(m[1], 16); const f = c => Math.min(255, Math.round(c + (255 - c) * 0.18)).toString(16).padStart(2, '0');
    return '#' + f(n >> 16) + f((n >> 8) & 255) + f(n & 255);
  };

  const swapMedia = variant => {
    if (!variant || !variant.featured_media) return;
    const shot = root.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
    if (!shot) return;
    if (matchMedia('(max-width: 920px)').matches) shot.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    else {
      const main = root.querySelector('.gshot.main img'), img = shot.querySelector('img');
      if (main && img && main !== img) { const src = img.currentSrc || img.src; main.src = src; if (img.srcset) main.srcset = img.srcset; }
    }
  };

  const update = () => {
    const vals = selected();
    const v = findVariant(vals);
    /* labels */
    groups.forEach((g, gi) => {
      const isTone = g.classList.contains('tonesel');
      $$('label', g).forEach(l => {
        const on = l.querySelector('input').checked;
        l.classList.toggle('on', on);
        /* availability given the other selected options */
        const test = vals.slice(); test[gi] = l.querySelector('input').value;
        const exists = product && product.variants.some(x => test.every((val, i) => val === null || x['option' + (i + 1)] === val));
        const avail = product && product.variants.some(x => x.available && test.every((val, i) => val === null || x['option' + (i + 1)] === val));
        l.classList.toggle('out', exists && !avail);
        if (on && isTone) {
          retint(l);
          const name = l.dataset.label || l.querySelector('input').value;
          if (toneName) toneName.textContent = name;
          if (toneVal) toneVal.textContent = (l.dataset.num ? '№ ' + String(l.dataset.num).padStart(2, '0') + ' · ' : '') + name;
          document.dispatchEvent(new CustomEvent('nabi:tone', { detail: { tone: name } }));
        }
      });
    });
    if (!v) {
      if (addBtn) { addBtn.disabled = true; addLabel.textContent = (window.nabiStrings && window.nabiStrings.unavailable) || 'unavailable'; }
      return;
    }
    idInput.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.hidden = false; compareEl.textContent = money(v.compare_at_price); } else compareEl.hidden = true; }
    if (addBtn) {
      addBtn.disabled = !v.available;
      addLabel.innerHTML = v.available ? defaultLabel : (window.nabiStrings && window.nabiStrings.soldOut) || 'sold out';
    }
    if (history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    swapMedia(v);
    document.dispatchEvent(new CustomEvent('nabi:variant', { detail: v }));
  };
  groups.forEach(g => g.addEventListener('change', update));

  /* quantity */
  const q = $('[data-pqty]');
  if (q) {
    $('[data-pqty-minus]').addEventListener('click', () => { q.value = Math.max(1, (parseInt(q.value, 10) || 1) - 1); });
    $('[data-pqty-plus]').addEventListener('click', () => { q.value = (parseInt(q.value, 10) || 1) + 1; });
  }

  /* add to bag via ajax */
  if (form) {
    let t;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const err = $('[data-form-error]');
      if (err) err.hidden = true;
      const id = parseInt(idInput.value, 10);
      const qty = q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
      if (!id) return;
      addBtn.classList.add('loading');
      try {
        await window.nabi.addToCart([{ id, quantity: qty }], { open: false });
        addBtn.classList.add('added');
        clearTimeout(t); t = setTimeout(() => { addBtn.classList.remove('added'); if (window.nabi.cartDrawerEnabled) window.nabi.openCart(); }, 1400);
      } catch (ex) {
        if (err) { err.textContent = ex.message; err.hidden = false; }
      }
      addBtn.classList.remove('loading');
    });
  }

  /* initial state: sync tone label + tint from the checked swatch */
  const checkedTone = root.querySelector('.tonesel input:checked');
  if (checkedTone) { retint(checkedTone.closest('label')); document.dispatchEvent(new CustomEvent('nabi:tone', { detail: { tone: checkedTone.value } })); }
  const initial = product && product.variants.find(v => v.id === parseInt(idInput.value, 10));
  if (initial) document.dispatchEvent(new CustomEvent('nabi:variant', { detail: initial }));
})();
